import MockAdapter from 'axios-mock-adapter/types'

export function mockEarnsDetail(mocker: MockAdapter) {
  mocker.onGet(RegExp('^/earns/trade/detail')).reply((config) => {
    return [
      200,
      {
        code: 200,
        data: {
          detail: {
            id: 1710604800015,
            userId: 264242,
            rollingNTradeAmount: 0.0,
            rollingMTradeAmount: 0.0,
            originalWithdrawAmount: 0.0,
            originalDepositAmount: 100000000.0,
            originalTradeAmount: 0.0,
            multiplyTradeAmount: 0.0,
            friendsTradeAmount: 0.0,
            friendsCount: 0,
            multiplyFriendsTradeAmount: 0.0,
            multiplyTotalAmount: 0.0,
            createdAt: 1711238400000,
            updatedAt: 1711238400000,
          },
          isV2User: false,
          isTodayLucky: false,
          isTomorrowLucky: false,
          top: 30,
          multiplier: 1,
          activityInfo: {
            name: 'earn',
            code: 'earn',
            startTime: 1710691200000,
            endTime: 1715097600000,
            valid: true,
            momentum: {
              rollingDays: 7,
              multipliers: {
                '0': 1,
                '500000': 1.5,
                '1000000': 2,
                '10000000': 3,
              },
            },
            task: {
              name: 'Trade by v2 user',
              multiplier: 2,
              type: 'CALLBACK',
              matches: [],
              period: null,
            },
            lucky: {
              multiplier: 2,
              minAmount: 10000,
            },
            referrals: [1, 1, 2],
          },
          dailyTaskEntities: [
            {
              name: 'Trade $TKO to use multiplier',
              multiplier: 2,
              type: 'SYMBOL',
              matches: ['103102'],
              period: 20240325,
            },
            {
              name: 'Trade by v2 user',
              multiplier: 2,
              type: 'CALLBACK',
              matches: [],
              period: 20240326,
            },
            {
              name: 'Make a withdrawal',
              multiplier: 2,
              type: 'TRADE',
              matches: ['WITHDRAW'],
              period: 20240327,
            },
          ],
        },
      },
    ]
  })
}
